import { Component, OnInit, Injector } from '@angular/core';
import { SecondPageEditBase, UserService } from 'vnpost-shared';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { TypeCustomerService } from '../../services/type-customer.service';
import { ServiceProductService } from '../../services/service-product.service';
import { ServiceCommissionsService } from '../../services/service-commissions-.service';
import { CategoryUnitService } from '../../services/category-unit.service';
@Component({
  selector: 'app-edit-commissions-for-service',
  templateUrl: './edit-commissions-for-service.component.html',
  styleUrls: ['./edit-commissions-for-service.component.css']
})
export class EditCommissionsForServiceComponent extends SecondPageEditBase implements OnInit {
  listStatus: { label: string; value: number }[] = [
    { label: 'Đang áp dụng', value: 1 },
    { label: 'Ngừng áp dụng', value: 0 },
  ];
  listServiceProduct: { label: string; value: string }[] = [];
  listCategoryUnit: { label: string; value: string }[] = [];
  listCustomerCategory: { label: string; value: string }[] = [];

  cols: any;

  commissionByCustomerCategories: any[] = [];
  isDisable: boolean;

  constructor(
    protected _serviceCommissionsService: ServiceCommissionsService,
    protected _serviceProductService: ServiceProductService,
    protected _categoryUnitService: CategoryUnitService,
    protected _typeCustomerService: TypeCustomerService,
    protected _injector: Injector,
  ) {
    super(_serviceCommissionsService, _injector);
    this.formGroup = new UntypedFormGroup({
      serviceProductCode: new UntypedFormControl('', [Validators.required]),
      unitCode: new UntypedFormControl('', [Validators.required]),
      status: new UntypedFormControl('')
    });
    this.cols = [
      { field: 'customerCategoryCode', header: 'Loại khách hàng', visible: true },
      { field: 'commissionRate', header: 'Hoa hồng được hưởng', visible: true },
      { field: 'action', header: 'Hành động', visible: true },
    ];
  }

  ngOnInit() {
  }

  onShowPopup(model: any) {
    this.isDisable = model.isDisable;
    if (this.listServiceProduct.length == 0) {
      this.getListServiceProduct();
    }
    if (this.listCategoryUnit.length == 0) {
      this.getListCategoryUnit();
    }
    if (this.listCustomerCategory.length == 0) {
      this.getListCustomerCategory();
    }
    this.validationSummary.resetErrorMessages();
    this.resetForm();

    if (model.id > 0) {
      this._serviceCommissionsService.getCommissionsForServiceDetail(model.id).then(
        (res) => {
          this.itemDetail = res.data;
          this.commissionByCustomerCategories = this.itemDetail.commissionByCustomerCategories ?? [];
          this.commissionByCustomerCategories.forEach(x => x.action = 'delete');
          this.commissionByCustomerCategories.push({
            customerCategoryCode: '',
            commissionRate: '0',
            action: 'add',
            id: 0
          });
          
        },
        (error) => {
          this._notifierService.showWarning(
            this._translateService.instant('MESSAGE.NOT_FOUND_ERROR')
          );
        }
      );
    }
  }

  getListServiceProduct() {
    this._serviceProductService.getListServiceProduct({status: 1}).then(res => {
      this.listServiceProduct = res?.data.map(x => ({label: `${x.serviceProductName} (${x.serviceProductCode})`, value: x.serviceProductCode}));
    },err => {
      this.listServiceProduct = []
    })
  }

  getListCategoryUnit() {
    this._categoryUnitService.getCategoryUnit({status: 1}).then(res => {
      this.listCategoryUnit = res?.data.map(x => ({label: `${x.unitName} (${x.unitCode})`, value: x.unitCode}));
    },err => {
      this.listCategoryUnit = []
    })
  }

  getListCustomerCategory() {
    this._typeCustomerService.getListTypeCustomer({status: 1}).then(res => {
      this.listCustomerCategory = res?.data.map(x => ({label: `${x.customerName} (${x.customerCode})`, value: x.customerCode}));
    },err => {
      this.listCustomerCategory = []
    })
  }

  onAddCommissionByCustomer(index: any) {
    if (!this.isDisable) {
      this.commissionByCustomerCategories[index].action = 'delete';
      this.commissionByCustomerCategories.push({
        customerCategoryCode: '',
        commissionRate: '0',
        action: 'add',
        id: 0
      })
    }
  }

  onDeleteCommissionByCustomer(index: any) {
    if (!this.isDisable) {
      this.commissionByCustomerCategories.splice(index, 1);
    }
  }

  async save() {
    this.submitting = true;

    if (this.formGroup.invalid) {
      this.submitting = false;
      this.validationSummary.showValidationSummary();
      return;
    }
    var commissionByCustomerCategoriesSave = this.commissionByCustomerCategories.filter(x => x.customerCategoryCode && x.customerCategoryCode.trim());

    var duplicateCustomerIndex = commissionByCustomerCategoriesSave.findIndex((x, index, cus) => cus.filter(c => c.customerCategoryCode === x.customerCategoryCode).length > 1);
    if (duplicateCustomerIndex > -1) {
      this.submitting = false;
      this._notifierService.showError(`Loại khách hàng dòng ${duplicateCustomerIndex + 1} đã tồn tại`);
      return;
    }

    var emptyRateIndex = commissionByCustomerCategoriesSave.findIndex(x => !x.commissionRate || x.commissionRate == 0);
    if (emptyRateIndex > -1) {
      this.submitting = false;
      this._notifierService.showError(`Hoa hồng dòng ${emptyRateIndex + 1} không được để trống`);
      return;
    }
    var invalidRateIndex = commissionByCustomerCategoriesSave.findIndex(x => !(/^100(\.00?)?$|^\d{1,2}(\.\d{1,2})?$/).test(x.commissionRate));
    if (invalidRateIndex > -1) {
      this.submitting = false;
      this._notifierService.showError(`Hoa hồng dòng ${invalidRateIndex + 1} không hợp lệ`);
      return;
    }
    this.itemDetail.commissionByCustomerCategories = this.commissionByCustomerCategories.filter(x => x.customerCategoryCode && x.customerCategoryCode.trim());
    this.onUpdate();
  }

  onUpdate() {
    this._serviceCommissionsService.update(this.itemDetail.id, this.itemDetail).then(
      (response) => {
        this.closePopupMethod(true);
        this._notifierService.showUpdateDataSuccess();
        this.onAfterSave();
        this.submitting = false;
      },
      (error) => {
        this._notifierService.showUpdateDataFailed();
        this.submitting = false;
      }
    );
  }
}